import React from 'react';
import _ from 'lodash';
import {
  convertHoursToDays,
  displayPriceFormat,
  formatCategoryName,
  getPendingOrderProductPriceWithoutPromo,
  getPendingOrderProductPriceWithPromo,
} from '../../utils';
import styles from './OrderItem.styles';
import { DISHOP_GREEN, UNIT } from '../../constants/configuration';
import { deleteItem, findOptionParent } from './OrderItem.services';
import { useAppSelector } from '../../redux/hook';
import OrderItemOption from './components/OrderItemOption';
import OrderItemInstruction from './components/OrderItemInstruction';
import Spinner from '../Spinner';
import SkeletonRow from '../Skeleton/SkeletonRow.view';

export default function OrderItem({
  deleteOption,
  cartItem,
  cartItemKey,
  isLoading = false,
}) {
  const { nb, unit = null, name, price, preparationTime } = cartItem;
  const { secondaryColor } = useAppSelector(
    (state) => state.configurationReducer
  );
  const {
    userConnected,
    user: { customerId },
    isUserAnonymous,
  } = useAppSelector((state) => state.userReducer);

  const displayPriceAsync = (price) =>
    isLoading ? <Spinner /> : displayPriceFormat(price);
  const renderOptions = () => {
    const { items } = cartItem;
    if (items) {
      return _.map(items, (item) => {
        if (item) {
          const { options, categoryKey } = item;
          const optionLabels = _.map(options, 'name');
          const isChild = _.some(
            items,
            (childItem) =>
              childItem?.categoryKey !== categoryKey &&
              categoryKey.includes(childItem?.categoryKey)
          );
          const prefix = isChild ? '- ' : '* ';
          const fontSize = isChild ? UNIT * 0.85 : UNIT * 0.9;
          const className = isChild ? 'ml-4' : 'ml-2';
          let { categoryName } = item;
          if (options && isChild) {
            _.forEach(options, (option) => {
              const optionParent = findOptionParent(option, items);
              if (optionParent) {
                categoryName = formatCategoryName({
                  shopCategory: { name: item.categoryName },
                  parentItemLabel: optionParent.label,
                  parentItemRecursiveKey: optionParent.itemRecursiveKey,
                  isMultiple: optionParent.categoryMultiple,
                });
              }
            });
          }
          const itemRenderString = `${prefix}${categoryName}: ${optionLabels.join(
            ','
          )}`;
          return (
            <OrderItemOption
              className={className}
              fontSize={fontSize}
              itemRenderString={itemRenderString}
              categoryId={item.categoryId}
            />
          );
        }
      });
    }
  };

  const hasPromo =
    getPendingOrderProductPriceWithoutPromo(price, cartItem) !==
    getPendingOrderProductPriceWithPromo(price, cartItem);

  return (
    <>
      <div>
        <SkeletonRow
          label={
            <div className={`row `}>
              {deleteOption && (
                <div className={`mr-2`}>
                  <a
                    href='#'
                    onClick={(e) => {
                      e.preventDefault();
                      deleteItem({
                        userConnected,
                        isUserAnonymous,
                        cartItem,
                        cartItemKey,
                        customerId,
                      });
                    }}
                  >
                    <i
                      className='far fa-trash-alt'
                      style={{ color: secondaryColor }}
                    />
                  </a>
                </div>
              )}
              <div className='col-8'>
                {unit ? (
                  <p style={{ ...styles.receiptProductItemTitleDefaultStyle }}>
                    <span className='no-localization'>
                      {nb} {unit}
                    </span>{' '}
                    de {name}
                  </p>
                ) : (
                  <p style={{ ...styles.receiptProductItemTitleDefaultStyle }}>
                    <span className='no-localization'>x {nb}</span> {name}
                  </p>
                )}
              </div>
            </div>
          }
          amount={
            <div style={{ display: 'flex', columnGap: '10px' }}>
              {hasPromo && (
                <div style={{ color: DISHOP_GREEN }}>
                  {displayPriceAsync(
                    getPendingOrderProductPriceWithPromo(price, cartItem)
                  )}
                </div>
              )}
              <div
                style={{ textDecoration: hasPromo ? 'line-through' : 'unset' }}
              >
                {displayPriceAsync(
                  getPendingOrderProductPriceWithoutPromo(price, cartItem)
                )}
              </div>
            </div>
          }
          isLoading={isLoading}
        />
        <div className={'pl-3 pl-sm-4'}>
          <SkeletonRow
            label={renderOptions()}
            isLoading={isLoading}
          />
          {cartItem.instruction && (
            <SkeletonRow
              label={
                <OrderItemInstruction instruction={cartItem.instruction} />
              }
              isLoading={isLoading}
            />
          )}
          {preparationTime > 0 && deleteOption && (
            <p
              className='ml-2 text-warning mb-0'
              style={{ fontSize: UNIT * 0.9 }}
            >
              {`~ ${
                convertHoursToDays(preparationTime) > 0
                  ? `${convertHoursToDays(preparationTime)} jour(s)`
                  : `${preparationTime} heure(s)`
              } de préparation`}
            </p>
          )}
        </div>
      </div>
      <hr className='my-4 hr' />
    </>
  );
}
